import { Workbox } from 'workbox-window';

// Cada cuánto se revisa si hay una versión nueva publicada
const INTERVALO_REVISAR_VERSION_MS = 60 * 60 * 1000;

let workbox = null;
let hayVersionNueva = false;
const suscriptores = new Set();

const notificar = () => suscriptores.forEach((fn) => fn());

export const suscribirVersionNueva = (fn) => {
    suscriptores.add(fn);
    return () => suscriptores.delete(fn);
};

export const versionNuevaDisponible = () => hayVersionNueva;

/* Registra el service worker (src/service-worker.js). Solo en producción:
   en `npm start` create-react-app no lo genera. */
export const registrarServiceWorker = () => {
    if (process.env.NODE_ENV !== 'production' || !('serviceWorker' in navigator)) return;

    workbox = new Workbox(`${process.env.PUBLIC_URL}/service-worker.js`);

    // Hay una versión nueva instalada esperando: se avisa en vez de recargar sola
    workbox.addEventListener('waiting', () => {
        hayVersionNueva = true;
        notificar();
    });

    workbox.register().then((registro) => {
        if (registro) setInterval(() => registro.update(), INTERVALO_REVISAR_VERSION_MS);
    });
};

// Activa la versión nueva y recarga la app cuando toma el control
export const actualizarApp = () => {
    if (!workbox) return;
    workbox.addEventListener('controlling', () => window.location.reload());
    workbox.messageSkipWaiting();
};
